<div class="e-search-container">
    <h1>Search the Via Database</h1>
    <p>{{ searchDescription }}</p>
    <div class="e-search-bar">
        <via-search-bar [matSelectPanelClass]="'e-landing-page-select-panel'"></via-search-bar>
    </div>
</div>

<div class="e-getting-started" role="region" aria-label="Getting started information">
    <div *ngFor="let tile of tiles">
        <via-information-tile [tile]="tile" (onButtonClicked)="openInfographicsModal(tile.infographicsName)"> </via-information-tile>
    </div>
</div>
